import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import { StyledPasswordCheck } from './styled'
import { ListItem, ListItemIcon } from "@material-ui/core"

export interface IPasswordCheckItemProps {
    label: string
    isEnabled: boolean | string[]
    theme: any
}

export const PasswordCheckItem = ({ label, isEnabled, theme }: IPasswordCheckItemProps) => {
    return (
        <ListItem style={{
                padding: '0 1rem',
            }}
        >
            <ListItemIcon style={{
                minWidth: 34,
            }}>
                {isEnabled ? <CheckCircleIcon style={{
                    fill: theme.colors.success,
                }} /> : <WarningIcon style={{
                    fill: theme.colors.error,
                }} />}
            </ListItemIcon>
            <StyledPasswordCheck primary={label} isEnabled={isEnabled} />
        </ListItem>
    )
}
